import { int } from "@goodgamestudios/math-utilities";
import { Poker2UserEvent } from "../../../event/Poker2UserEvent";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Dialog } from "../Poker2Dialog";
import { AbstractTeaser } from "./common/AbstractTeaser";
import { TeaserFeatureFactory } from "./common/TeaserFeatureFactory";
import { TeaserVO } from "./common/TeaserVO";
import { Poker2FeatureDialogProperties } from "./Poker2FeatureDialogProperties";

import MovieClip = createjs.MovieClip;
import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2FeatureDialog extends Poker2Dialog {
    public static NAME: string = "Poker2FeatureDialog";
    private _teaserVO: TeaserVO;
    private _teaser: AbstractTeaser;

    constructor(disp: Container) {
        super(disp);
    }

    protected init(): void {
        super.init();
    }

    public get isUnique(): boolean {
        return false;
    }

    protected applyProperties(): void {
        this._teaserVO = TeaserFeatureFactory.getTeaserFeatureById(this.featureDialogProperties.featureId);
        this._teaser = this._teaserVO.teaserInstance;
        this.featureDialogContainer.addChild(this._teaserVO.teaserInstance);

        // fill texts
        this._teaser.fillTexts(this._teaserVO.teaserTextsVO);
        // button labels have te be filled after executing 'updateAllTextFields()' due to issues with languages like russian or
        // chinese, which are using special fonts.
        this._teaser.fillButtonLabels();

        this.updatePosition();
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);

        switch (event.target.name) {
            case "btn_close":
                this.hide();
                break;
            case "btn_shop":
                this.switchToShop();
                this.hide();
                break;
            case "btn_ok":
                this.hide();
                break;
        }
    }

    private fillItems(mc: MovieClip, id: number): void {
        var textChildren: number = int(mc.mc_textcontainer.numChildren);

        for (var i: number = 0; i < textChildren; i++) {
            mc.mc_textcontainer["txt_" + i].text = Poker2Model.languageData.getTextById("feature_" + id + "_text_" + i);
        }
    }

    private switchToShop(): void {
        this.layoutManager.state = 12;
        this.controller.dispatchEvent(new Poker2UserEvent("changeShopState", ["stateShop"]));
    }

    protected get featureDialogProperties(): Poker2FeatureDialogProperties {
        return this.properties as Poker2FeatureDialogProperties;
    }

    private get featureDialogContainer(): Container {
        return this.disp as Container;
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    public set isUnique(value/*:Boolean*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Dialog.prototype, "isUnique").set.call(this, value);
    }
}
import { Poker2LayoutManager } from "../../Poker2LayoutManager";
import { Poker2ShopScreen } from "../../screens/Poker2ShopScreen";
